"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const OptionsButton_1 = __importDefault(require("../../atoms/OptionsButton"));
const Tooltip_1 = require("../../atoms/Tooltip");
const DrawOptions_1 = __importDefault(require("../DrawOptions"));
const GrowthSettingsPopup_1 = __importDefault(require("../GrowthSettingsPopup"));
const bridge_1 = require("@completeanatomy/bridge");
const colors_1 = require("../../utils/colors");
const TooltipWithModal_1 = __importDefault(require("../../atoms/TooltipWithModal"));
const providers_1 = require("../../providers");
const growthOptionsHandlers_1 = require("../../utils/growthOptionsHandlers");
const colors = [
    ui_1.colorPalette.persimmon,
    ui_1.colorPalette.permanentGeraniumLake,
    ui_1.colorPalette.dustyPink,
    ui_1.colorPalette.saberToothedTiger,
    ui_1.colorPalette.safflowerKite,
    ui_1.colorPalette.rosette,
    ui_1.colorPalette.acajou,
];
function ToolsGrowthOptionsPanel({ className, color, size, opacity, particleSize = 75, }) {
    const [isSettingsOpen, toggleSettings] = (0, ui_1.useToggleState)(false);
    const [isColorActive, setColorActive] = (0, react_1.useState)(false);
    const [selectedColor, setSelectedColor] = (0, react_1.useState)(color);
    const [selectedSize, setSelectedSize] = (0, react_1.useState)(size);
    const [selectedParticleSize, setSelectedParticleSize] = (0, react_1.useState)(particleSize);
    const bridge = (0, bridge_1.useBridge)();
    const buttonRef = (0, react_1.useRef)();
    const tools = (0, providers_1.useToolsService)();
    const growthManager = tools === null || tools === void 0 ? void 0 : tools.getThreeDToolManager();
    const onChangeColor = (0, growthOptionsHandlers_1.createOnChangeColorHandler)({
        bridge,
        growthManager,
        opacity,
        particleSize,
        size,
        setSelectedColor,
    });
    const onChangeSize = (0, growthOptionsHandlers_1.createOnChangeSizeHandler)({
        bridge,
        growthManager,
        color,
        opacity,
        particleSize,
        setSelectedSize,
    });
    const onChangeOpacity = (0, growthOptionsHandlers_1.createOnChangeOpacityHandler)({
        bridge,
        growthManager,
        color,
        particleSize,
        size,
    });
    const onChangeParticleSize = (0, growthOptionsHandlers_1.createOnChangeParticleSizeHandler)({
        bridge,
        growthManager,
        color,
        opacity,
        size,
        setSelectedParticleSize,
    });
    const handleToggleColorActive = (active) => {
        setColorActive(active);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Overlay, { shown: isColorActive, zIndex: 0, "data-e2e": 'ToolsGrowthOptionsPanel_Overlay' }), (0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'ToolsGrowthOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(SettingsButton, { forwardedRef: buttonRef, colorActive: isColorActive, onClick: toggleSettings, "data-e2e": 'ToolsGrowthOptionsPanel_SettingsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Settings, "data-e2e": 'ToolsGrowthOptionsPanel_ButtonIcon' }) }), (0, jsx_runtime_1.jsx)(SettingsTooltip, { position: Tooltip_1.TooltipPosition.Top, padding: { width: 0, height: 0 }, isOpen: isSettingsOpen, onToggle: toggleSettings, targetElement: buttonRef.current, "data-e2e": 'ToolsGrowthOptionsPanel_SettingsTooltip', children: (0, jsx_runtime_1.jsx)(GrowthSettingsPopup_1.default, { particleSize: selectedParticleSize, onChangeParticleSize: onChangeParticleSize, "data-e2e": 'ToolsGrowthOptionsPanel_ToolsGrowthSettingsPopup' }) }), (0, jsx_runtime_1.jsx)(ColorsContainer, { active: isColorActive, "data-e2e": 'ToolsGrowthOptionsPanel_ColorsContainer', children: (0, jsx_runtime_1.jsx)(StyledToolsDrawOptionsPanel, { colors: colors, color: (0, colors_1.rgbComponentsToHex)(selectedColor || ''), size: selectedSize, sizes: [4, 3, 2, 1], initialOpacity: opacity, withOpacity: true, onToggle: handleToggleColorActive, onChangeColor: onChangeColor, onChangeSize: onChangeSize, onChangeOpacity: onChangeOpacity, "data-e2e": 'ToolsGrowthOptionsPanel_StyledToolsDrawOptionsPanel' }) })] })] }));
}
exports.default = ToolsGrowthOptionsPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
`;
const SettingsButton = (0, styled_components_1.default)(OptionsButton_1.default) `
  z-index: 1; /* put button over color options */

  margin: 0 20px 0 0;

  transform: translateY(${({ colorActive }) => (colorActive ? '150%' : 0)});

  transition: transform 0.2s ease-in;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 35px;
  height: 35px;
`;
const SettingsTooltip = (0, styled_components_1.default)(TooltipWithModal_1.default) `
  border-radius: 8px;
`;
const ColorsContainer = styled_components_1.default.div `
  position: relative;

  transform: translateX(${({ active }) => (active ? '-40px' : 0)});

  transition: transform 0.2s ease-in;
`;
const StyledToolsDrawOptionsPanel = (0, styled_components_1.default)(DrawOptions_1.default) `
  position: absolute;
  top: 0;
  left: 0;
`;
